// Employee master (the Management → Employees database). A structured people record — unlike the
// Overtime roster, which is just an ordered list of names. The two are linked: an active employee is
// carried onto the Overtime roster automatically (see the worker's employees data layer), so the
// printable overtime cards stay in step with who actually works here.
/** Assembly-floor teams an employee can belong to. An employee may be in several at once. */
export const EMPLOYEE_TEAMS = ['Teak', 'AnF', 'Assembly'];
//# sourceMappingURL=employee.js.map